import { SvgMaxDimensions, SvgCustoms, SvgAccount, SvgParcel, SvgEnquiryExclamation } from '@parcel2go/core-ui';

interface props {
  error: string;
}

export function ErrorCodeIcon(props: props) {
  switch (props.error) {
    case 'ITEM-DIMENSIONS':
      return <SvgMaxDimensions />;
    case 'PRODUCT-TARIFFCODE-TOO-SHORT':
    case 'PRODUCT-TARIFFCODE-REQUIRED':
      return <SvgCustoms />;
    default:
  }

  if (props.error.startsWith('ADDRESS-')) {
    return <SvgAccount />;
  }

  if (props.error.startsWith('PRODUCT-') || props.error.startsWith('ITEM-')) {
    return <SvgParcel />;
  }

  return <SvgEnquiryExclamation />;
}
